import React from 'react';

function AvisoP () {
    return (
        <div>
            
            <div>
                <div>
                    <h2>Aviso de privacidad</h2>
                    
                    <h4>
                    El Palacio de Hierro, S.A. de C.V. (en adelante "El Palacio de Hierro") 
                    con domicilio en Durango No. 230 Col. Roma, Alcaldía Cuauhtémoc, Ciudad 
                    de México, C.P. 06700 será el responsable del tratamiento de sus datos 
                    personales.

                    Para cualquier duda relacionada con la protección de sus datos personales
                    podrá contactar a nuestra Oficina de Privacidad de Datos en la dirección 
                    de correo electrónico privacidaddedatos@ph.com.mx.
                    </h4>
                </div>
                

            </div>
        </div>
    )
}

export default AvisoP